import React from 'react';
import { MDBCard, MDBCardBody } from 'mdb-react-ui-kit';

const PlatformDistribution = () => {
  const platformData = [
    { name: 'eBay', value: 35, color: '#e53238' },
    { name: 'Shopify', value: 28, color: '#5e8e3e' },
    { name: 'Poshmark', value: 18, color: '#731a3d' },
    { name: 'Vinted', value: 12, color: '#097770' },
    { name: 'Depop', value: 7, color: '#ff6b6b' }
  ];

  const total = platformData.reduce((sum, item) => sum + item.value, 0);

  return (
    <MDBCard className="dashboard-card distribution-card">
      <MDBCardBody>
        <div className="card-header">
          <h3 className="card-title">Platform Distribution</h3>
          <p className="card-subtitle">Products listed by marketplace</p>
        </div>
        
        <div className="stacked-chart">
          <div className="stacked-bars">
            {platformData.map((platform, index) => (
              <div
                key={platform.name}
                className="stacked-bar"
                style={{
                  height: `${(platform.value / total) * 100}%`,
                  backgroundColor: platform.color,
                  animationDelay: `${index * 0.2}s`
                }}
                data-tooltip={`${platform.name}: ${platform.value}%`}
              ></div>
            ))}
          </div>
          
          <div className="platform-legend">
            {platformData.map((platform, index) => (
              <div key={platform.name} className="legend-item">
                <div 
                  className="legend-color" 
                  style={{ backgroundColor: platform.color }}
                ></div>
                <div className="legend-text">
                  <span className="legend-name">{platform.name}</span>
                  <span className="legend-value">{platform.value}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default PlatformDistribution;